import React from "react";
import PropTypes from "prop-types";

import "./RefundTextField.sass";

function RefundTextField({
  value,
  handleValue,
  errorMsg,
  className,
  inputClass,
  errorClass,
  children,
  ...rest
}) {
  return (
    <div className={`field ${className}`}>
      <input
        {...rest}
        className={`field__input ${inputClass} ${
          errorMsg !== "" ? "field__input--error" : ""
        }`}
        value={value}
        onChange={handleValue}
      />
      {errorMsg !== "" && (
        <span className={`field__error ${errorClass}`}>{errorMsg}</span>
      )}
      {children}
    </div>
  );
}

// --- propTypes --- //
RefundTextField.propTypes = {
  value: PropTypes.string.isRequired,
  handleValue: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  className: PropTypes.string,
  inputClass: PropTypes.string,
  errorClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
RefundTextField.defaultProps = {
  errorMsg: "",
  className: "",
  inputClass: "",
  errorClass: "",
  children: null,
};
// --- propTypes --- //

export default RefundTextField;
